module.exports = __webpack_public_path__ + "img/unit-dark.54473e1d.svg";